import { useClikArtPlacementOptional } from '@/contexts/clikart-placement-context'
import {
  type UsePlacementCanvasBridgeArgs,
  usePlacementCanvasBridge,
} from '@/hooks/use-placement-canvas-bridge'
import { isClikArtDropBlockedByTextChain } from '@/lib/clikart/linked-text-clikart-drop-policy'

type ClikArtPlacementCanvasBridgeProps = Omit<
  UsePlacementCanvasBridgeArgs,
  'placement' | 'isBlockedByTextChain'
>

/**
 * ClikArt-side counterpart of `photo-placement-canvas-bridge.tsx`'s `PhotoPlacementCanvasBridge`.
 * Reuses `isPhotoDropTarget` as-is (inside `usePlacementCanvasBridge`) — the set of fillable shape
 * kinds (rectangle/irregular-polygon/regular-polygon/closed-pen-path) is identical for a ClikArt
 * drop, only the *source* of the fill differs. Whether the hit shape currently carries text (and
 * so needs the "replace text?" confirmation instead of filling silently) is decided later, in
 * `home.tsx`'s `handleFillShapeWithClikArt` — exactly where the photo path makes the same call —
 * not here.
 */
export function ClikArtPlacementCanvasBridge(props: ClikArtPlacementCanvasBridgeProps) {
  usePlacementCanvasBridge({
    ...props,
    placement: useClikArtPlacementOptional(),
    isBlockedByTextChain: isClikArtDropBlockedByTextChain,
  })

  return null
}
